var React = require('react');

function TwiterInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.5 3.00751C15.75 3.37501 15.015 3.52426 14.25 3.75001C13.4092 2.80126 12.1627 2.74876 10.965 3.19726C9.76725 3.64576 8.98275 4.74226 9 6.00001V6.75001C6.56625 6.81226 4.39875 5.70376 3 3.75001C3 3.75001 -0.1365 9.32476 6 12C4.596 12.9353 3.19575 13.566 1.5 13.5C3.981 14.8523 6.68475 15.3173 9.0255 14.6378C11.7105 13.8578 13.917 11.8455 14.7637 8.83126C15.0163 7.91451 15.1418 6.9674 15.1365 6.01651C15.135 5.82976 16.269 3.93751 16.5 3.00676V3.00751Z","stroke":"black","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

TwiterInline.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = TwiterInline;

TwiterInline.default = TwiterInline;
